import { render, staticRenderFns } from "./IndividualSoldPinReport.vue?vue&type=template&id=5c477870&scoped=true"
import script from "./IndividualSoldPinReport.vue?vue&type=script&lang=js"
export * from "./IndividualSoldPinReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c477870",
  null
  
)

export default component.exports